import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import Text from 'tio-ui/components/text';
import type { ComponentLike } from '@glint/template';

interface BoostActionLinkSignature {
  Args: {
    /**
     * Ember route to navigate to
     */
    route: string;
    /**
     * Icon component to display
     */
    icon: ComponentLike<{ Args: { size: number }; Element: SVGElement }>;
    /**
     * Action description text
     */
    label: string;
    /**
     * Points value to display (e.g., "+15 pts")
     */
    points: string;
    /**
     * Icon color class
     * @default "tio-boost-action-icon"
     */
    iconClass?: string;
  };
  Element: HTMLAnchorElement;
}

/** Routes to a score-boost action, displaying its icon, label, and point value. */
const BoostActionLink: TOC<BoostActionLinkSignature> = <template>
  <LinkTo
    @route={{@route}}
    class="tio-row-between p-3 tio-bg-surface rounded-lg hover:shadow-sm transition-shadow"
    ...attributes
  >
    <div class="tio-row-tight">
      <@icon @size={{18}} class={{if @iconClass @iconClass "tio-boost-action-icon"}} />
      <Text @size="sm">{{@label}}</Text>
    </div>
    <Text @size="sm" @weight="medium" class="tio-fg-success">{{@points}}</Text>
  </LinkTo>
</template>;

export default BoostActionLink;
